module.exports = __webpack_public_path__ + "static/media/independence-seaport-museum.02de9593.md";